import StandSearchModal from "./stand-search-modal";

export default StandSearchModal;